export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function highlightMatch(
  text: string,
  query: string,
  highlightClass = 'search-input__highlight',
): string {
  const safeText = escapeHtml(text);
  const normalizedQuery = query.trim();

  if (!normalizedQuery) {
    return safeText;
  }

  const pattern = new RegExp(escapeRegExp(normalizedQuery), 'gi');

  return safeText.replace(pattern, `<span class="${highlightClass}">$&</span>`);
}

export function formatMatchCountSummary(count: number, query: string): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  let word: string;

  if (mod10 === 1 && mod100 !== 11) {
    word = 'совпадение';
  } else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    word = 'совпадения';
  } else {
    word = 'совпадений';
  }

  const q = escapeHtml(query);
  const summary = `${count} ${word} для <span class="search-input__query">«${q}»</span>`;

  if (count === 0) {
    return `${summary}<span class="search-summary__hint">Проверьте орфографию или измените запрос.</span>`;
  }

  return summary;
}

export function textIncludesQuery(text: string, query: string): boolean {
  const normalizedQuery = query.trim().toLocaleLowerCase('ru-RU');
  if (!normalizedQuery) return true;

  return text.toLocaleLowerCase('ru-RU').includes(normalizedQuery);
}
